export const UserType = {
  ADMIN: 'admin',
  SUPER_ADMIN: 'superadmin',
  LEAD: 'lead',
  DEVELOPER: 'developer',
};
